import { render, staticRenderFns } from "./ListImages.vue?vue&type=template&id=05f10c2f&scoped=true"
import script from "./ListImages.vue?vue&type=script&lang=js"
export * from "./ListImages.vue?vue&type=script&lang=js"
import style0 from "./ListImages.vue?vue&type=style&index=0&id=05f10c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f10c2f",
  null
  
)

export default component.exports